import hoistNonReactStatistics from 'hoist-non-react-statics';
import React from 'react';
import { OptionTypeBase } from 'react-select';
import { default as SelectBase } from 'react-select/async';
import InputSkeleton from '../components/input-skeleton';
import AbstractSelect from './abstract-select';
import { AsyncSelectProps } from './select.types';

const AsyncSelect = <
  OptionType extends OptionTypeBase = { label: React.ReactNode; value: any },
  IsMulti extends boolean = false,
>(
  props: AsyncSelectProps<OptionType, IsMulti>,
  ref?: React.Ref<SelectBase<OptionType, IsMulti>>,
) => <AbstractSelect ref={ref} {...props} Component={SelectBase as any} />;

AsyncSelect.Prefix = InputSkeleton.Prefix;
AsyncSelect.Icon = InputSkeleton.Icon;

export default hoistNonReactStatistics(
  React.forwardRef(AsyncSelect),
  AsyncSelect,
) as typeof AsyncSelect;
